<p-toast />

<div class="cep-lookup-container">
  <h2>CEP Lookup</h2>
  <p class="hint">
    Digite o CEP — os demais campos serão preenchidos automaticamente.
  </p>

  <form [formGroup]="form" class="form-b4a" (submit)="submit()">
    <span class="p-float-label">
      <p-inputMask
        inputId="cep"
        mask="99999-999"
        formControlName="cep"
        [ngClass]="{ 'ng-invalid ng-dirty': invalidControl('cep') }"
        (onComplete)="onCepComplete()"
      />
      <label for="cep">CEP *</label>
      <small
        class="error"
        *ngIf="form.get('cep')?.errors?.['viaCepNotFound']"
      >
        CEP não encontrado no ViaCEP
      </small>
    </span>

    <span class="p-float-label">
      <input
        pInputText
        id="logradouro"
        type="text"
        formControlName="logradouro"
        [ngClass]="{ 'ng-invalid ng-dirty': invalidControl('logradouro') }"
      />
      <label for="logradouro">Logradouro *</label>
    </span>

    <span class="p-float-label">
      <input
        pInputText
        id="bairro"
        type="text"
        formControlName="bairro"
        [ngClass]="{ 'ng-invalid ng-dirty': invalidControl('bairro') }"
      />
      <label for="bairro">Bairro *</label>
    </span>

    <span class="p-float-label">
      <input
        pInputText
        id="cidade"
        type="text"
        formControlName="cidade"
        [ngClass]="{ 'ng-invalid ng-dirty': invalidControl('cidade') }"
      />
      <label for="cidade">Cidade *</label>
    </span>

    <span class="p-float-label">
      <input
        pInputText
        id="uf"
        type="text"
        formControlName="uf"
        maxlength="2"
        [ngClass]="{ 'ng-invalid ng-dirty': invalidControl('uf') }"
      />
      <label for="uf">UF *</label>
    </span>

    <div class="buttons">
      <p-button
        *ngIf="!cepExists"
        type="submit"
        label="Salvar"
        icon="pi pi-save"
        [disabled]="form.invalid || form.disabled"
      />
    </div>
  </form>
</div>
